import {
  FETCH_ROSTER_ATTENDANCE_REQUEST,
  FETCH_ROSTER_ATTENDANCE_SUCCESS,
  FETCH_ROSTER_ATTENDANCE_FAILURE,
  FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
  FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
  FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
  FETCH_ABSENT_SUMMARY_REQUEST,
  FETCH_ABSENT_SUMMARY_SUCCESS,
  FETCH_ABSENT_SUMMARY_FAILURE,
} from "../constants/RosterAttendanceConstants";

import RosterAttendanceService from "../service/RosterAttendanceService";

export const fetchRosterAttendance = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ROSTER_ATTENDANCE_REQUEST });

    const data = await RosterAttendanceService.getByDate(date);

    dispatch({
      type: FETCH_ROSTER_ATTENDANCE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ROSTER_ATTENDANCE_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchRosterAbsentDetails = (date, location = '') => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ROSTER_ABSENT_DETAILS_REQUEST });

    const data = await RosterAttendanceService.getAbsentDetailsForRoster(date, location);

    dispatch({
      type: FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

// Fetch absent summary by location (GetAbsentDetailsAll API)
export const fetchAbsentSummary = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ABSENT_SUMMARY_REQUEST });

    const data = await RosterAttendanceService.getAbsentDetailsAll(date);

    dispatch({
      type: FETCH_ABSENT_SUMMARY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ABSENT_SUMMARY_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};





// import {
//   FETCH_ROSTER_ATTENDANCE_REQUEST,
//   FETCH_ROSTER_ATTENDANCE_SUCCESS,
//   FETCH_ROSTER_ATTENDANCE_FAILURE,
//   FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
//   FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//   FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
// } from "../constants/RosterAttendanceConstants";

// import RosterAttendanceService from "../service/RosterAttendanceService";

// export const fetchRosterAttendance = (date) => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_ROSTER_ATTENDANCE_REQUEST });

//     const data = await RosterAttendanceService.getByDate(date);

//     dispatch({
//       type: FETCH_ROSTER_ATTENDANCE_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ROSTER_ATTENDANCE_FAILURE,
//       payload:
//         error.response?.data?.message || error.message || "Failed to fetch",
//     });
//   }
// };

// export const fetchRosterAbsentDetails = (date, location = '') => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_ROSTER_ABSENT_DETAILS_REQUEST });

//     const data = await RosterAttendanceService.getAbsentDetailsForRoster(date, location);

//     dispatch({
//       type: FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
//       payload:
//         error.response?.data?.message || error.message || "Failed to fetch",
//     });
//   }
// };


//   import {
//   FETCH_ROSTER_ATTENDANCE_REQUEST,
//   FETCH_ROSTER_ATTENDANCE_SUCCESS,
//   FETCH_ROSTER_ATTENDANCE_FAILURE,
//   FETCH_ROSTER_ABSENT_DETAILS_REQUEST,
//   FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//   FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
// } from "../constants/RosterAttendanceConstants";

// import RosterAttendanceService from "../service/RosterAttendanceService";

// export const fetchRosterAttendance = (date) => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_ROSTER_ATTENDANCE_REQUEST });

//     const data = await RosterAttendanceService.getByDate(date);

//     dispatch({
//       type: FETCH_ROSTER_ATTENDANCE_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ROSTER_ATTENDANCE_FAILURE,
//       payload:
//         error.response?.data?.message || error.message || "Failed to fetch",
//     });
//   }
// };

// export const fetchRosterAbsentDetails = (date, location = '') => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_ROSTER_ABSENT_DETAILS_REQUEST });

//     const data = await RosterAttendanceService.getAbsentDetailsForRoster(date, location);

//     dispatch({
//       type: FETCH_ROSTER_ABSENT_DETAILS_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ROSTER_ABSENT_DETAILS_FAILURE,
//       payload:
//         error.response?.data?.message || error.message || "Failed to fetch",
//     });
//   }
// };
